import { VscListFlat } from "react-icons/vsc";

export const NoDataDetails = () => (
  <div className="w-full mt-4">
    {/* <div className="w-full flex flex-col items-center justify-center h-[120px] bg-white border border-[#D0D5DD] rounded-xl mb-6">
      <div className="h-12 w-12 bg-[#F0F6FF] rounded-full flex items-center justify-center mb-3">
        <VscListFlat className="text-[#0075E3]" />
      </div>
      <h1 className="text-[15px] font-[500] font-inter text-[#344054]">
        Select a stock to uncover its financial story
      </h1>
    </div> */}

    <div className="w-full grid grid-cols-[1fr_332px] gap-6">
      <div className="flex flex-col gap-5">
        <div className="vi-glass-card p-6 animate-pulse">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-[14px] bg-[#E4E0D6] flex-shrink-0" />
            <div className="flex-1 flex flex-col gap-2">
              <div className="h-6 w-48 bg-[#E4E0D6] rounded-md" />
              <div className="h-4 w-72 bg-[#F0EDE8] rounded-md" />
            </div>
            <div className="flex flex-col items-end gap-2">
              <div className="h-7 w-24 bg-[#E4E0D6] rounded-md" />
              <div className="h-4 w-16 bg-[#F0EDE8] rounded-md" />
            </div>
          </div>
          <div className="mt-5 bg-[#F0EDE8] rounded-[14px] h-16" />
        </div>

        {Array.from({ length: 2 }).map((_, i) => (
          <div
            key={i}
            className="vi-glass-card p-6 animate-pulse"
          >
            <div className="flex items-center gap-3 mb-4">
              <div className="w-[38px] h-[38px] rounded-[11px] bg-[#E4E0D6]" />
              <div className="flex flex-col gap-1.5">
                <div className="h-5 w-44 bg-[#E4E0D6] rounded-md" />
                <div className="h-3.5 w-32 bg-[#F0EDE8] rounded-md" />
              </div>
            </div>
            <div className="flex flex-col gap-2 mb-4">
              <div className="h-4 w-full bg-[#F0EDE8] rounded-md" />
              <div className="h-4 w-5/6 bg-[#F0EDE8] rounded-md" />
              <div className="h-4 w-4/6 bg-[#F0EDE8] rounded-md" />
            </div>
            <div className="grid grid-cols-3 gap-3">
              {Array.from({ length: 3 }).map((_, j) => (
                <div
                  key={j}
                  className="vi-beg-metric-tile rounded-[13px] p-3.5"
                >
                  <div className="h-3.5 w-3/4 bg-[#F0EDE8] rounded mb-2" />
                  <div className="h-6 w-1/2 bg-[#E4E0D6] rounded mb-1.5" />
                  <div className="h-3 w-2/3 bg-[#F0EDE8] rounded mb-2.5" />
                  <div className="h-1.5 w-full bg-[#E4E0D6] rounded-full" />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="flex flex-col gap-4">
        <div className="vi-glass-card p-5 animate-pulse">
          <div className="h-5 w-32 bg-[#E4E0D6] rounded mb-4" />
          {Array.from({ length: 7 }).map((_, i) => (
            <div
              key={i}
              className="flex justify-between py-2 border-b border-dashed border-[#E4E0D6] last:border-0"
            >
              <div className="h-3.5 w-24 bg-[#F0EDE8] rounded" />
              <div className="h-3.5 w-16 bg-[#E4E0D6] rounded" />
            </div>
          ))}
        </div>

        <div className="vi-glass-card p-5 animate-pulse">
          <div className="h-5 w-28 bg-[#E4E0D6] rounded mb-4" />
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="mb-3">
              <div className="h-4 w-28 bg-[#E4E0D6] rounded mb-1.5" />
              <div className="h-3.5 w-full bg-[#F0EDE8] rounded" />
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export const LoadingData = () => {
  return (
    <div className="vi-glass-card flex flex-col items-center justify-center h-96 w-full mt-2 p-2 mb-10">
      <div className="w-8 h-8 border-4 border-[#0075E3] border-t-transparent rounded-full animate-spin mb-4"></div>
      <div className="text-[#101828] font-inter">Loading Analysis …</div>
      <div className="text-[#667085] font-inter text-sm">
        This may take a few seconds based on your selected stock
      </div>
    </div>
  );
};
